// Team exclusion fields (input[data-team-picker]): own dropdown instead of the browser's datalist, fuzzy matching with
// short names ("Bayern", "BVB", "Gladbach"), and exactly one team per field: lists ("Bayern, HSV"), leagues and
// continents are rejected, an unclear entry has to be picked from the list. Same file in the prototype and the theme.
// window.mpTeamPicker.validate(root) checks all fields in root before adding to the cart.
(() => {
  // [Name, ...short names]. More teams: add a line; the theme can add extra names via data-team-extra on the field.
  const TEAMS = [
    // Germany
    ['FC Bayern München', 'Bayern', 'FCB', 'Bayern München'], ['Borussia Dortmund', 'BVB', 'Dortmund'], ['RB Leipzig', 'Leipzig'],
    ['Bayer 04 Leverkusen', 'Leverkusen', 'Bayer'], ['Eintracht Frankfurt', 'Frankfurt', 'SGE'], ['VfB Stuttgart', 'Stuttgart'],
    ['SC Freiburg', 'Freiburg'], ['VfL Wolfsburg', 'Wolfsburg'], ['Borussia Mönchengladbach', 'Gladbach', 'BMG'],
    ['1. FC Union Berlin', 'Union Berlin', 'Union'], ['Werder Bremen', 'Bremen', 'SVW'], ['TSG Hoffenheim', 'Hoffenheim'],
    ['1. FSV Mainz 05', 'Mainz'], ['FC Augsburg', 'Augsburg', 'FCA'], ['1. FC Heidenheim', 'Heidenheim'], ['FC St. Pauli', 'St. Pauli', 'Pauli'],
    ['Hamburger SV', 'HSV', 'Hamburg'], ['1. FC Köln', 'Köln', 'Effzeh'], ['VfL Bochum', 'Bochum'], ['Holstein Kiel', 'Kiel'],
    ['FC Schalke 04', 'Schalke', 'S04'], ['Hertha BSC', 'Hertha'], ['Fortuna Düsseldorf', 'Düsseldorf', 'Fortuna'], ['Hannover 96', 'Hannover'],
    ['1. FC Nürnberg', 'Nürnberg', 'FCN'], ['1. FC Kaiserslautern', 'Kaiserslautern', 'FCK', 'Lautern'], ['Karlsruher SC', 'KSC', 'Karlsruhe'],
    ['SC Paderborn 07', 'Paderborn'], ['SV Darmstadt 98', 'Darmstadt', 'Lilien'], ['Eintracht Braunschweig', 'Braunschweig'],
    ['Hansa Rostock', 'Rostock'], ['Dynamo Dresden', 'Dresden'], ['1. FC Magdeburg', 'Magdeburg'], ['SpVgg Greuther Fürth', 'Fürth'],
    ['Arminia Bielefeld', 'Bielefeld'], ['Preußen Münster', 'Münster'], ['SV Elversberg', 'Elversberg'], ['SSV Ulm 1846', 'Ulm'],
    ['Jahn Regensburg', 'Regensburg'], ['TSV 1860 München', '1860', 'Löwen', 'Sechzig'], ['MSV Duisburg', 'Duisburg'], ['Alemannia Aachen', 'Aachen'],
    ['Rot-Weiss Essen', 'RWE', 'Essen'], ['Energie Cottbus', 'Cottbus'], ['Waldhof Mannheim', 'Mannheim', 'Waldhof'], ['Kickers Offenbach', 'Offenbach', 'OFC'],
    ['Erzgebirge Aue', 'Aue'], ['1. FC Saarbrücken', 'Saarbrücken', 'FCS'], ['VfL Osnabrück', 'Osnabrück'], ['SV Sandhausen', 'Sandhausen'],
    // England
    ['Manchester City', 'Man City', 'City'], ['Manchester United', 'Man United', 'Man Utd', 'ManU', 'United'], ['FC Liverpool', 'Liverpool', 'LFC'],
    ['FC Arsenal', 'Arsenal'], ['FC Chelsea', 'Chelsea'], ['Tottenham Hotspur', 'Tottenham', 'Spurs'], ['Newcastle United', 'Newcastle'],
    ['Aston Villa', 'Villa'], ['West Ham United', 'West Ham'], ['Brighton & Hove Albion', 'Brighton'], ['Crystal Palace', 'Palace'],
    ['FC Everton', 'Everton'], ['FC Fulham', 'Fulham'], ['FC Brentford', 'Brentford'], ['Wolverhampton Wanderers', 'Wolves', 'Wolverhampton'],
    ['AFC Bournemouth', 'Bournemouth'], ['Nottingham Forest', 'Forest', 'Nottingham'], ['Leicester City', 'Leicester'], ['Leeds United', 'Leeds'],
    ['FC Southampton', 'Southampton'], ['Ipswich Town', 'Ipswich'], ['AFC Sunderland', 'Sunderland'], ['FC Burnley', 'Burnley'],
    ['Sheffield United', 'Sheffield'], ['FC Watford', 'Watford'], ['Norwich City', 'Norwich'], ['West Bromwich Albion', 'West Brom'],
    ['FC Middlesbrough', 'Middlesbrough', 'Boro'], ['Coventry City', 'Coventry'], ['Stoke City', 'Stoke'], ['Blackburn Rovers', 'Blackburn'],
    ['Derby County', 'Derby'], ['Queens Park Rangers', 'QPR'], ['AFC Wrexham', 'Wrexham'],
    // Spain
    ['Real Madrid', 'Real', 'Madrid'], ['FC Barcelona', 'Barcelona', 'Barca', 'Barça'], ['Atlético Madrid', 'Atletico'], ['FC Sevilla', 'Sevilla'],
    ['Real Betis', 'Betis'], ['FC Valencia', 'Valencia'], ['FC Villarreal', 'Villarreal'], ['Real Sociedad', 'Sociedad'],
    ['Athletic Bilbao', 'Bilbao', 'Athletic Club'], ['Celta Vigo', 'Celta'], ['CA Osasuna', 'Osasuna'], ['FC Girona', 'Girona'],
    ['RCD Mallorca', 'Mallorca'], ['Rayo Vallecano', 'Rayo'], ['FC Getafe', 'Getafe'], ['Espanyol Barcelona', 'Espanyol'],
    ['Deportivo Alavés', 'Alaves'], ['UD Las Palmas', 'Las Palmas'], ['Deportivo La Coruña', 'Deportivo', 'La Coruna'], ['Real Zaragoza', 'Zaragoza'], ['FC Málaga', 'Malaga'],
    // Italy
    ['Juventus Turin', 'Juventus', 'Juve'], ['AC Mailand', 'AC Milan', 'Milan'], ['Inter Mailand', 'Inter', 'Inter Milan'], ['SSC Neapel', 'Napoli', 'Neapel'],
    ['AS Rom', 'AS Roma', 'Roma'], ['Lazio Rom', 'Lazio'], ['Atalanta Bergamo', 'Atalanta'], ['AC Florenz', 'Fiorentina', 'Florenz'],
    ['FC Bologna', 'Bologna'], ['FC Turin', 'Torino'], ['Udinese Calcio', 'Udinese'], ['CFC Genua', 'Genoa', 'Genua'], ['Sampdoria Genua', 'Sampdoria'],
    ['US Sassuolo', 'Sassuolo'], ['Parma Calcio', 'Parma'], ['Como 1907', 'Como'], ['Hellas Verona', 'Verona'], ['Cagliari Calcio', 'Cagliari'],
    ['US Lecce', 'Lecce'], ['FC Venedig', 'Venezia'], ['US Palermo', 'Palermo'],
    // France
    ['Paris Saint-Germain', 'PSG', 'Paris'], ['Olympique Marseille', 'Marseille', 'OM'], ['Olympique Lyon', 'Lyon', 'OL'], ['AS Monaco', 'Monaco'],
    ['OSC Lille', 'Lille'], ['Stade Rennes', 'Rennes'], ['OGC Nizza', 'Nizza', 'Nice'], ['RC Lens', 'Lens'], ['FC Nantes', 'Nantes'],
    ['Racing Straßburg', 'Straßburg', 'Strasbourg'], ['Girondins Bordeaux', 'Bordeaux'], ['AS Saint-Étienne', 'Saint-Etienne'], ['FC Toulouse', 'Toulouse'],
    ['Stade Reims', 'Reims'], ['HSC Montpellier', 'Montpellier'],
    // Rest of Europe
    ['Ajax Amsterdam', 'Ajax'], ['PSV Eindhoven', 'PSV', 'Eindhoven'], ['Feyenoord Rotterdam', 'Feyenoord'], ['AZ Alkmaar', 'AZ'], ['FC Twente', 'Twente'], ['FC Utrecht', 'Utrecht'],
    ['Benfica Lissabon', 'Benfica'], ['FC Porto', 'Porto'], ['Sporting Lissabon', 'Sporting', 'Sporting CP'], ['Sporting Braga', 'Braga'],
    ['Celtic Glasgow', 'Celtic'], ['Rangers FC', 'Glasgow Rangers', 'Rangers'], ['FC Aberdeen', 'Aberdeen'], ['Heart of Midlothian', 'Hearts'], ['Hibernian Edinburgh', 'Hibernian', 'Hibs'],
    ['Galatasaray Istanbul', 'Galatasaray', 'Gala'], ['Fenerbahçe Istanbul', 'Fenerbahce'], ['Beşiktaş Istanbul', 'Besiktas'], ['Trabzonspor'],
    ['FC Basel', 'Basel'], ['BSC Young Boys', 'Young Boys', 'YB'], ['FC Zürich', 'Zürich'], ['RB Salzburg', 'Salzburg'], ['Rapid Wien', 'Rapid'],
    ['Austria Wien', 'Austria'], ['Sturm Graz', 'Sturm'], ['FC Brügge', 'Brügge', 'Club Brugge'], ['RSC Anderlecht', 'Anderlecht'], ['Royal Antwerpen', 'Antwerpen'],
    ['KRC Genk', 'Genk'], ['FC Kopenhagen', 'Kopenhagen'], ['Brøndby IF', 'Brondby'], ['Olympiakos Piräus', 'Olympiakos'], ['Panathinaikos Athen', 'Panathinaikos'],
    ['AEK Athen', 'AEK'], ['PAOK Saloniki', 'PAOK'], ['Schachtar Donezk', 'Schachtar'], ['Dynamo Kiew', 'Kiew'], ['Roter Stern Belgrad', 'Roter Stern', 'Crvena Zvezda'],
    ['Partizan Belgrad', 'Partizan'], ['Dinamo Zagreb', 'Zagreb'], ['Hajduk Split', 'Hajduk'], ['Sparta Prag', 'Sparta'], ['Slavia Prag', 'Slavia'],
    ['Legia Warschau', 'Legia'], ['Zenit St. Petersburg', 'Zenit'], ['Malmö FF', 'Malmö'], ['Rosenborg Trondheim', 'Rosenborg'],
    // Rest of the world
    ['Boca Juniors', 'Boca'], ['River Plate', 'River'], ['CR Flamengo', 'Flamengo'], ['SE Palmeiras', 'Palmeiras'], ['SC Corinthians', 'Corinthians'],
    ['FC Santos', 'Santos'], ['FC São Paulo', 'Sao Paulo'], ['Fluminense'], ['Grêmio Porto Alegre', 'Gremio'], ['SC Internacional', 'Internacional'],
    ['Club América', 'America'], ['Chivas Guadalajara', 'Chivas'], ['Cruz Azul'], ['Tigres UANL', 'Tigres'], ['CF Monterrey', 'Monterrey'],
    ['Inter Miami', 'Miami'], ['LA Galaxy', 'Galaxy'], ['Los Angeles FC', 'LAFC'], ['New York Red Bulls', 'NY Red Bulls'], ['Seattle Sounders', 'Sounders'],
    ['Al-Nassr', 'Al Nassr'], ['Al-Hilal', 'Al Hilal'], ['Al-Ittihad', 'Al Ittihad'], ['Melbourne City'], ['Urawa Red Diamonds', 'Urawa'], ['Kawasaki Frontale', 'Kawasaki'],
    // National teams
    ['Deutschland', 'DFB', 'Germany'], ['Österreich', 'Austria Nationalteam'], ['Schweiz'], ['Frankreich', 'France'], ['England'], ['Spanien', 'Spain'],
    ['Italien', 'Italy'], ['Niederlande', 'Holland'], ['Portugal'], ['Belgien'], ['Kroatien'], ['Dänemark'], ['Schweden'], ['Norwegen'], ['Polen'],
    ['Türkei'], ['Schottland'], ['Wales'], ['Irland'], ['Ukraine'], ['Tschechien'], ['Serbien'], ['Griechenland'], ['Ungarn'],
    ['Brasilien', 'Brazil'], ['Argentinien'], ['Uruguay'], ['Kolumbien'], ['Chile'], ['Mexiko'], ['USA'], ['Kanada'], ['Japan'], ['Südkorea'],
    ['Australien'], ['Marokko'], ['Senegal'], ['Nigeria'], ['Ghana'], ['Elfenbeinküste'], ['Kamerun'], ['Ägypten'], ['Algerien'], ['Tunesien'],
    ['Saudi-Arabien'], ['Katar'], ['Iran'], ['Ecuador'], ['Peru'], ['Paraguay'], ['Jamaika'], ['Costa Rica']
  ];
  // Whole leagues, continents and lists can't be excluded.
  const BLOCKED = /\b(bundesliga|premier league|la ?liga|serie a|ligue 1|eredivisie|liga|league|europa|afrika|asien|sudamerika|suedamerika|nordamerika|ozeanien|kontinent|alle|nationalmannschaften|nationalteams)\b/;
  const LIST = /[,;/&+]|\s(und|and|oder|or)\s/i;
  const MSG = {
    one: 'Bitte nur ein Team pro Feld.',
    blocked: 'Ganze Ligen, Nationen-Gruppen oder Kontinente können nicht ausgeschlossen werden.',
    pick: 'Bitte wähle ein Team aus der Liste.',
    twice: 'Dieses Team ist schon ausgewählt.'
  };

  const norm = text => String(text).toLowerCase().replace(/ß/g, 'ss').normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
  const entries = list => list.map(([name, ...alias]) => ({ name, keys: [name, ...alias].map(norm) }));
  let teams = entries(TEAMS);

  // Score: exact name/short name > starts with > every typed word starts a word > contains.
  const score = (entry, q) => {
    let best = 0;
    const words = q.split(' ');
    entry.keys.forEach(key => {
      const parts = key.split(' ');
      let s = 0;
      if (key === q) s = 100;
      else if (key.startsWith(q)) s = 80 - Math.min(20, key.length - q.length);
      else if (words.every(w => parts.some(p => p.startsWith(w)))) s = 60;
      else if (q.length > 2 && key.includes(q)) s = 40;
      best = Math.max(best, s);
    });
    return best;
  };
  const search = (text, limit = 8) => {
    const q = norm(text);
    if (!q) return [];
    return teams.map(entry => ({ entry, s: score(entry, q) })).filter(r => r.s > 0)
      .sort((a, b) => b.s - a.s || a.entry.name.length - b.entry.name.length).slice(0, limit).map(r => r.entry);
  };
  const canonical = text => teams.find(entry => entry.keys.includes(norm(text)));

  const enhance = input => {
    if (input.dataset.teamReady) return;
    input.dataset.teamReady = '1';
    input.removeAttribute('list');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    if (input.dataset.teamExtra) teams = teams.concat(entries(input.dataset.teamExtra.split('\n').map(t => t.trim()).filter(Boolean).filter(t => !canonical(t)).map(t => [t])));
    const wrap = document.createElement('span');
    wrap.className = 'team-picker';
    input.replaceWith(wrap);
    wrap.append(input);
    const list = document.createElement('ul');
    list.className = 'team-list';
    list.id = `${input.name.replace(/\W+/g, '-')}-list`;
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    input.setAttribute('aria-controls', list.id);
    const error = document.createElement('small');
    error.className = 'team-error';
    error.setAttribute('role', 'alert');
    error.hidden = true;
    wrap.append(list, error);
    let active = -1;
    let results = [];

    const close = () => { list.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
    const paint = () => [...list.children].forEach((li, i) => {
      li.setAttribute('aria-selected', String(i === active));
      if (i === active) li.scrollIntoView({ block: 'nearest' });
    });
    const open = () => {
      results = search(input.value);
      list.innerHTML = results.map((entry, i) => `<li role="option" id="${list.id}-${i}" aria-selected="false">${entry.name.replace(/[&<>]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' })[c])}</li>`).join('')
        || (input.value.trim() ? `<li class="team-empty" aria-disabled="true">${MSG.pick}</li>` : '');
      list.hidden = !list.children.length;
      input.setAttribute('aria-expanded', String(!list.hidden));
      active = results.length ? 0 : -1;
      paint();
    };
    const choose = entry => { input.value = entry.name; close(); setError(''); input.dispatchEvent(new Event('change', { bubbles: true })); };
    const setError = message => { error.textContent = message; error.hidden = !message; wrap.classList.toggle('is-error', Boolean(message)); };

    input.addEventListener('input', () => { setError(LIST.test(input.value) ? MSG.one : ''); open(); });
    input.addEventListener('focus', () => { if (input.value) open(); });
    input.addEventListener('keydown', event => {
      if (list.hidden && event.key === 'ArrowDown') { open(); return; }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (!results.length) return;
        active = (active + (event.key === 'ArrowDown' ? 1 : -1) + results.length) % results.length;
        paint();
      } else if (event.key === 'Enter' && !list.hidden && results[active]) {
        event.preventDefault();
        choose(results[active]);
      } else if (event.key === 'Escape') close();
    });
    list.addEventListener('mousedown', event => {
      const li = event.target.closest('li[role=option]');
      if (!li) return;
      event.preventDefault();
      choose(results[[...list.children].indexOf(li)]);
    });
    input.addEventListener('blur', () => { setTimeout(close, 120); check(input); });
    input.mpTeamError = setError;
  };

  // One field: empty is fine; otherwise one known team (a single clear match is completed automatically).
  const check = input => {
    const set = input.mpTeamError || (() => {});
    const value = input.value.trim();
    if (!value) { set(''); return true; }
    if (LIST.test(value)) { set(MSG.one); return false; }
    if (BLOCKED.test(norm(value)) && !canonical(value)) { set(MSG.blocked); return false; }
    let entry = canonical(value);
    if (!entry) {
      const found = search(value, 2);
      if (found.length === 1 || (found.length > 1 && score(found[0], norm(value)) >= 80 && score(found[1], norm(value)) < 80)) entry = found[0];
    }
    if (!entry) { set(MSG.pick); return false; }
    input.value = entry.name;
    const others = [...document.querySelectorAll('input[data-team-picker]')].filter(other => other !== input && (other.form === input.form || other.getAttribute('form') === input.getAttribute('form')));
    if (others.some(other => norm(other.value) === norm(entry.name))) { set(MSG.twice); return false; }
    set('');
    return true;
  };

  const validate = (root = document) => {
    const inputs = [...root.querySelectorAll('input[data-team-picker]')];
    const ok = inputs.map(check).every(Boolean);
    if (!ok) {
      const details = inputs[0]?.closest('details');
      if (details) details.open = true;
      inputs.find(input => input.closest('.team-picker')?.classList.contains('is-error'))?.focus();
    }
    return ok;
  };
  const init = (root = document) => root.querySelectorAll('input[data-team-picker]').forEach(enhance);

  window.mpTeamPicker = { init, validate, search };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();
